import React, { useEffect } from "react"
import { connect } from "react-redux"
import styled from "@emotion/styled"

import PrevButton from "../prevbutton"
import { triggerGlobalUnmount, setShowBackBtn } from "../../actions"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const HeaderText = styled(TextElementNova)`
  line-height: 16px !important;
  @media (min-width: 768px) {
    font-size: 14px !important;
    line-height: 20px !important;
  }

  @media (min-width: 1024px) {
    font-size: 16px !important;
    line-height: 24px !important;
  }
`
const PrevButtonWrap = styled.div`
  display: inline-block;
  width: auto;
`

const BackButton = props => {

  const { showBackBtn, setShowBackBtn } = props

  const {
    currentSection,
    quizProgress,
    userToken,
    id,
    text,
    triggerGlobalUnmount,
    currentGlobalId,
  } = props

  useEffect(() => {
    if (currentSection.indexOf("intro") > -1) {
      setShowBackBtn(currentGlobalId !== "")
    } else {
      setShowBackBtn(currentSection !== "results")
    }
  }, [currentSection, quizProgress, setShowBackBtn, currentGlobalId])

  const introClick = () => {
    if (currentSection === "intro" && quizProgress === 0) {
      setShowBackBtn(false)
    }
  }

  return (
    <>
      {currentSection.indexOf("results") > -1 ? (
        <>
          <HeaderText text={`Results`} element="p" className="CTA-10-Dia-Normal text-nova-base-black show-small-only" />
          <HeaderText text={`Quiz Results`} element="p" className="CTA-10-Dia-Normal text-nova-base-black hide-small-only" />
        </>

      ) : (
        <>
          {!showBackBtn ? (
            <HeaderText text={`Hair Wellness Quiz`} element="p" className="CTA-20-Dia-Normal text-nova-base-black" />
          ) : (
            <PrevButtonWrap onClick={introClick}>
              <PrevButton
                mobileBack={true}
                id={id}
                text={text}
                token={userToken}
                triggerGlobalUnmount={triggerGlobalUnmount}
              />
            </PrevButtonWrap>
          )}
        </>
      )}
    </>
  )
}

const mapStateToProps = state => {
  return {
    currentSection: state.sectionReducer.currentSection,
    quizProgress: state.progressReducer.quizProgress,
    currentGlobalId: state.globalIdReducer.currentGlobalId,
    showBackBtn: state.progressReducer.showBackBtn,
  }
}

export default connect(mapStateToProps, {
  triggerGlobalUnmount,
  setShowBackBtn,
})(BackButton)
